import React from 'react';
import styled from 'styled-components';
import Card from './Card';

const Container = styled.div`
  .check {
    color: brown;
  }
  h3:hover {
    color: red;
  }
`;
const CardContent = () => (
  <Container>
    <section className="section">
      <h3 className="column is-7 is-offset-2 has-text-weight-bold is-size-5  has-text-centered">
        {' '}
        LATEST NEWS
      </h3>
      <h1 className=" check is-size-3 has-text-weight-bold column is-7 is-offset-2 has-text-centered">
        OUR BLOGS
      </h1>
      <a className="hover">
        <div className="container">
          <div className="columns">
            <div className="column">
              <div className="card-image text">
                <Card
                  img="/images/family.jpg"
                  title="5 REASONS WHY ANNUAL FAMILY PORTRAITS ARE A MUST!"
                  date="May 19, 2022  by Creative Studio"
                  subtitle="Family living are of all kinds in today’s society – nuclear, joint, solo-living. In this fast paced..."
                  linkTo="/blog/blogpage1"
                />
              </div>
            </div>

            <div className="column">
              <div className="card-image">
                <Card
                  img="/images/single_offer_img_1.png"
                  title="Three Ideas for Post Wedding Couple Photoshoot Photography"
                  date="June 26, 2019  by Creative Studio"
                  subtitle="A wedding is certainly an important event in our lives. Not just for the bride and the groom but their..."
                  linkTo="/blog/blogpage2"
                />
              </div>
            </div>
            <div className="column">
              <div className="card-image">
                <Card
                  img="/images/businessphotography.jpg"
                  title="Business portrait photography"
                  date="February 5,2019 by Creative Studio"
                  subtitle="Competition is everywhere. It would be an understatement if we were to say that the world is reeking..."
                  linkTo="/blog/blogpage3"
                />
              </div>
            </div>
          </div>
        </div>
      </a>
    </section>
  </Container>
);
export default CardContent;
